import { HeartHandshake, ShieldCheck, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { ABOUT_IMAGE } from "@/data/site";

const PILLARS = [
  {
    icon: HeartHandshake,
    title: "Ambiente acolhedor e sofisticado",
    text: "Cada detalhe do espaço foi pensado para que você se sinta em casa, com privacidade e tranquilidade.",
  },
  {
    icon: ShieldCheck,
    title: "Atendimento personalizado",
    text: "Ouvimos sua história e suas expectativas para construir um plano de cuidado só seu, sem pressa.",
  },
  {
    icon: Sparkles,
    title: "Estética natural e saúde bucal",
    text: "Técnica e sensibilidade para resultados harmoniosos, que respeitam a naturalidade do seu sorriso.",
  },
];

export const About = () => {
  return (
    <section id="sobre" data-testid="about-section" className="section-padding scroll-mt-24 bg-background">
      <div className="container-site grid items-center gap-14 lg:grid-cols-12 lg:gap-16">
        <Reveal className="relative order-2 lg:order-1 lg:col-span-5">
          <div
            aria-hidden="true"
            className="absolute -left-4 -top-4 h-full w-full rounded-[var(--radius)] bg-[hsl(var(--brand-beige))]"
          />
          <img
            src={ABOUT_IMAGE}
            alt="Recepção da clínica RAMALIVE com balcão branco e logotipo na parede"
            className="relative aspect-[4/5] w-full rounded-[var(--radius)] object-cover shadow-[0_20px_60px_rgba(20,16,12,0.12)]"
            loading="lazy"
            data-testid="about-image"
          />
        </Reveal>

        <div className="order-1 flex flex-col gap-10 lg:order-2 lg:col-span-7">
          <Reveal>
            <SectionHeading
              id="about"
              eyebrow="Sobre a clínica"
              title="Conforto, técnica e um atendimento que respeita seu tempo."
              description="Na RAMALIVE ODONTOLOGIA, acreditamos que cuidar do sorriso vai além do procedimento. Criamos um espaço onde conforto, discrição e excelência clínica caminham juntos, para que cada visita seja uma experiência leve e acolhedora."
            />
          </Reveal>

          <div className="grid gap-4 sm:grid-cols-1">
            {PILLARS.map((p, i) => (
              <Reveal key={p.title} delay={0.08 * i}>
                <div
                  className="card-premium flex gap-5 p-5 transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_14px_40px_rgba(20,16,12,0.10)]"
                  data-testid={`about-pillar-${i}`}
                >
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[hsl(var(--brand-beige))] text-[hsl(var(--brand-soft-brown))]">
                    <p.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-foreground">{p.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-muted-foreground sm:text-base">{p.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
